export const GET_BARANGAY_PROFILE =
  'BARANGAY_PROFILE/get_barangay_profile';
export const GET_SINGLE_BARANGAY_PROFILE =
  'BARANGAY_PROFILE/get_single_barangay_profile';
export const UPDATE_BARANGAY_PROFILE =
  'BARANGAY_PROFILE/update_barangay_profile';
export const CREATE_BARANGAY_PROFILE =
  'BARANGAY_PROFILE/create_barangay_profile';
export const REMOVE_BARANGAY_PROFILE =
  'BARANGAY_PROFILE/remove_barangay_profile';
export const GET_OTHER_FEE_CODES_LIST =
  'BARANGAY_PROFILE/get_other_fee_codes_list';
export const GET_ORDINANCE_REVISION =
  'BARANGAY_PROFILE/get_ordinance_revision';
  
export const FORM_DATA = {
  barangay_name: '',
  barangay_code: '',
  logo: '',
  signatory_name: '',
  signatory_designation: '',
  signatory_signature: '',
  for_new: 0,
  for_renewal: 0,
  with_barangay_clearance: 0,
  other_fee_codes: []
};
